// Tab-scoped persistence for the traffic ticket lookup flow.
//
// The MST store is rebuilt from `defaultStore` on every hard refresh, so the
// search results, selected ticket, and fetcher context are lost and the user
// is bounced back to the first lookup page (results/attorney/checkout/success
// all guard on `fetcherTickets.length` and redirect to `/traffic/lookup` when
// empty). sessionStorage holds the minimal slice needed to rebuild the flow
// on the next mount — tab-scoped, so it dies when the tab closes (natural
// abandon semantics) and never reaches the backend or other tabs.
//
// Mirrors utilities/flowPersistence.js (parking flow) and
// utilities/localStorage.js (trafficLookupForm, a separate cross-session
// prefill draft with a longer, intentionally different lifetime).
const STORAGE_KEY = "winit:trafficLookupFlowState"

export const loadFlowState = () => {
  if (typeof window === "undefined") return null
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY)
    return raw ? JSON.parse(raw) : null
  } catch (e) {
    return null
  }
}

export const saveFlowState = (slice) => {
  if (typeof window === "undefined") return
  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(slice))
  } catch (e) {
    // Best-effort — quota/private-mode failures must not break the flow.
  }
}

export const clearFlowState = () => {
  if (typeof window === "undefined") return
  try {
    window.sessionStorage.removeItem(STORAGE_KEY)
  } catch (e) {
    // ignore
  }
}
